export default "__VITE_ASSET__Dj5$j_Xc__"